import '../lib/boomerang';
import '../lib/newrelic';
import 'rollbar';
import 'lodash';
import 'jquery';
import 'angular';
import 'dakolech-ng-rollbar';
import 'jquery-mousewheel';
import '../lib/jquery-ui-1.12.1/jquery-ui';
import '../lib/jquery-migrate';
import 'jquery.animate-number';
import 'perfect-scrollbar/dist/js/perfect-scrollbar.jquery';
import 'bootstrap';
import 'bootstrap-select';
import 'bootstrap-contextmenu';
import 'bootstrap-slider';
import 'mousetrap';
import 'angular-cookie';
import 'angular-animate';
import 'angular-loading-bar';
import 'angular-ui-router';
import 'angular-ui-sortable';
import 'angular-permission';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-dragdrop';
import 'angular-bootstrap-show-errors';
import codemirror from 'codemirror';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/display/placeholder';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/sql/sql';
import 'codemirror/addon/dialog/dialog';
import 'codemirror/addon/tern/tern';
import 'moment';
import 'eonasdan-bootstrap-datetimepicker';
import 'bootstrap-toggle';
import 'chartist';
import 'angular-ui-grid';
import 'messageformat';
import '../lib/ui-codemirror-0.3.0/ui-codemirror';
import 'graphlib';
import 'dagre';
import 'ng-dialog';
import 'angular-filter';
import '../lib/offline-0.7.17/offline.min';
import 'fuckadblock';
import 'angular-md5';
import 'angular-utils-pagination';
import 'clipboard';
import 'bootstrap-daterangepicker';
import 'angular-ui-bootstrap';
import 'jwt-decode';
import 'cronstrue';
import 'angular-translate';
import 'angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files';
import 'angular-translate/dist/angular-translate-interpolation-messageformat/angular-translate-interpolation-messageformat';

(window as any).CodeMirror = codemirror;
